/**
 * Tiny Shopify app-block entry (<10KB limit).
 * Loads the full product-options.js and keeps the CTA visible before it arrives.
 */
(function () {
  "use strict";

  function forceVisible(root) {
    if (!root) return;
    try {
      // Keep Liquid placeholder clipped until main JS relocates + marks ready.
      // Forcing visibility here caused the bottom-of-page button flash.
      if (root.getAttribute("data-tf-ready") !== "1") {
        root.setAttribute("data-tf-pending", "1");
        return;
      }
      root.hidden = false;
      root.removeAttribute("hidden");
      root.removeAttribute("data-tf-empty");
      root.removeAttribute("data-tf-pending");
      root.style.setProperty("display", "block", "important");
      root.style.setProperty("visibility", "visible", "important");
      root.style.setProperty("opacity", "1", "important");
      var btn = root.querySelector("[data-tf-open-panel], .tf-po__open");
      if (btn) {
        btn.hidden = false;
        btn.removeAttribute("hidden");
        btn.style.setProperty("display", "inline-flex", "important");
        btn.style.setProperty("visibility", "visible", "important");
        btn.style.setProperty("opacity", "1", "important");
      }
      var wrap = root.closest(".shopify-block");
      if (wrap) {
        wrap.style.setProperty("display", "block", "important");
        wrap.style.setProperty("visibility", "visible", "important");
      }
    } catch (e) {
      /* ignore */
    }
  }

  function loadMain(src) {
    if (!src) return;
    var existing = document.querySelector(
      'script[data-tf-main-script="1"][src="' + src + '"]',
    );
    if (existing) return;
    var script = document.createElement("script");
    script.src = src;
    script.defer = true;
    script.setAttribute("data-tf-main-script", "1");
    document.head.appendChild(script);
  }

  function bootNodes() {
    var nodes = document.querySelectorAll("[data-tf-product-options]");
    for (var i = 0; i < nodes.length; i++) {
      forceVisible(nodes[i]);
      var src = nodes[i].getAttribute("data-main-script");
      if (src) loadMain(src);
    }
  }

  function watchForNewBlocks() {
    if (window.__TFPO_BLOCK_OBSERVER__) return;
    if (typeof MutationObserver === "undefined") return;
    window.__TFPO_BLOCK_OBSERVER__ = true;
    var obs = new MutationObserver(function () {
      bootNodes();
      // Re-run main boot if available (theme section re-renders).
      if (typeof window.__TFPO_REBOOT__ === "function") {
        window.__TFPO_REBOOT__();
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  function boot() {
    bootNodes();
    watchForNewBlocks();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
